import { render, staticRenderFns } from "./RadioGraphyExam.vue?vue&type=template&id=1765d7ec&scoped=true&"
import script from "./RadioGraphyExam.vue?vue&type=script&lang=js&"
export * from "./RadioGraphyExam.vue?vue&type=script&lang=js&"
import style0 from "./RadioGraphyExam.vue?vue&type=style&index=0&id=1765d7ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765d7ec",
  null
  
)

export default component.exports